import { usePermissions } from '@/features/auth';
import { useVehicleAmendments } from '@/features/vehiclesearch/hooks/useVehicleAmendments';
import { isListPanelFocusable } from '../utils/listPanelFocus';

/** Gated on `vehicle.read` as well as the id: politeness, not the boundary. Without it
 *  no request is made and the log is not rendered at all. */
export function useAgreementVehicleAmendments(vehicleId: string | null | undefined) {
    const { hasPermission } = usePermissions();
    const id = vehicleId || undefined;
    const canView = !!id && hasPermission({ resource: 'vehicle', action: 'read' });
    const amendments = useVehicleAmendments(canView ? id : undefined);

    return {
        canView,
        amendments,
        focusablePanel:
            !canView ||
            isListPanelFocusable({
                isLoading: amendments.query.isLoading,
                isError: amendments.query.isError,
                hasFocusableAction: false,
                lastPage: amendments.query.data?.meta.lastPage,
            }),
    };
}
